import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: `${process.env.REACT_APP_API_AUTH}/auth`,
  realm: process.env.REACT_APP_API_AUTH_REALM,
  clientId: process.env.REACT_APP_API_AUTH_CLIENT_ID,
});

export default keycloak;